import TsaSignName from '@/components/RealName/SignName.vue'
let $vm
let watcher

const plugin = {
  install (vue, pluginOptions = {}) {
    const SignName = vue.extend(TsaSignName)
    if (!$vm) {
      $vm = new SignName({
        el: document.createElement('div')
      })
      document.body.appendChild($vm.$el)
    }

    const signName = {
      show (options = {}) {
        // destroy watcher
        watcher && watcher()
        watcher = $vm.$watch('status', (val) => {
          val && options.onChange && options.onChange($vm.value)
        })
        
        $vm.show = true
        $vm.width = options.width
        $vm.height = options.height
        $vm.ratio = options.ratio || 0
        // Object.keys(options).map(key => {
        //   $vm[key] = options[key]
        // })
      },
      hide () {
        $vm.show = false
      }
    }
    if (!vue.prototype.$TsaSignName) {
      vue.prototype.$TsaSignName = signName
    }
  }
}

export default plugin
